import classnames from "classnames";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import { usePaywallCheckerContext } from "scmp-app/components/article/article-paywall-checker/contexts";
import { Loading } from "scmp-app/components/common/loading";
import { useMutationObserver } from "scmp-app/lib/hooks";
import type { articlePaywallContainerArticle$key } from "scmp-app/queries/__generated__/articlePaywallContainerArticle.graphql";

import { ArchiveWallContainerClass, PianoMeteringContainerClass } from "./consts";
import { Container, LoadingContainer, Wrapper } from "./styles";

type Props = {
  className?: string;
  isShowInlinePaywall?: boolean;
  reference: articlePaywallContainerArticle$key;
};

/**
 * This component is for showing inline paywall, ArchiveWallContainerClass is the class config in piano
 * It will replace the content in all element with class ArchiveWallContainerClass, so we need to remove the class once loaded the content
 * isShowPaywall will be undefined in the beginning and set the value (true / false) after piano executed
 */
export const ArticlePaywallContainer = forwardRef<HTMLDivElement, Props>(
  ({ className, isShowInlinePaywall, reference }, domReference) => {
    const article = useFragment(
      graphql`
        fragment articlePaywallContainerArticle on Article {
          entityId
        }
      `,
      reference,
    );

    const { setPaywallIsDomChangedMap } = usePaywallCheckerContext();
    const { captureTargetElement, element } = useMutationObserver(
      () => {
        if (!element) return;
        setPaywallIsDomChangedMap?.(map => ({
          ...map,
          [article.entityId]: true,
        }));
      },
      {
        childList: true,
      },
    );
    return (
      <Container
        $isShowPaywall={isShowInlinePaywall}
        className={classnames(className, PianoMeteringContainerClass)}
        ref={captureTargetElement}
      >
        <LoadingContainer>
          <Loading />
        </LoadingContainer>
        <Wrapper
          className={isShowInlinePaywall === undefined ? ArchiveWallContainerClass : ""}
          ref={domReference}
        />
      </Container>
    );
  },
);

ArticlePaywallContainer.displayName = "ArticlePaywallContainer";
